import { clsx } from 'clsx'

import type { TextProps } from './Text.types'

export const Text = (props: TextProps) => {
  const { className, children, ...rest } = props

  const classNames = clsx('Text', className)

  return (
    <p className={classNames} {...rest}>
      {children}
    </p>
  )
}
